import { RouteComponentProps } from 'react-router-dom';
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Permission } from "../../misc/api/apiTypes";

export type UseHistoryType = RouteComponentProps['history'];

export const GoBackToList = (history: UseHistoryType, currentUserPermissions: Permission[], sessionListRoute: string, analysisPermission: PermissionEnum, analysisListRoute: string) => {
    currentUserPermissions.map(p => p.Id).includes(analysisPermission) ? history.push(analysisListRoute) : history.push(sessionListRoute);
}
